module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pembayaran-detail"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/pembayaran'
      }
    }
  }, [_vm._v("List Pembayaran User")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Manual Input")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Manual Input Transaksi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.isUserValidated) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtUserInfo),
      expression: "txtUserInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "2",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.txtUserInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtUserInfo = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.doQueryUser()
      }
    }
  }, [_vm._v("\n                    Check\n                  ")])])]), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Product")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.product_id),
      expression: "form.product_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "product_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('option', {
      key: product.id,
      domProps: {
        "value": product.id
      }
    }, [_vm._v("\n                      [" + _vm._s(product.type) + "] " + _vm._s(product.title) + "\n                    ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Payment Method")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.payment_id),
      expression: "form.payment_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "payment_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.paymentMethods), function(paymentMethod) {
    return _c('option', {
      key: paymentMethod.id,
      domProps: {
        "value": paymentMethod.id
      }
    }, [_vm._v("\n                      [" + _vm._s(paymentMethod.type) + "] " + _vm._s(paymentMethod.bank_name) + "\n                    ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("User Bank Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bank_name),
      expression: "form.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bank_name", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("User Bank Account")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.account_name),
      expression: "form.account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "account_name", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Payment Slip")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.form.payment_slip_url) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    ref: "banner",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.form.payment_slip_url,
      "alt": "avatar"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('app-imagecropper', {
    attrs: {
      "aspectRatio": 2
    },
    on: {
      "finished": function($event) {
        return _vm.onFileChanged($event)
      }
    }
  })], 1)])])]) : _vm._e()])])]), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("\n                SIMPAN\n              ")]), _c('br')])])]) : _vm._e()])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Input Transaksi")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-175df0ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pembayaran/Form.vue
// module id = 1289
// module chunks = 0